export default __webpack_public_path__ + "e61be89722b6946f351616c88992e196.svg";